'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('packages.ctrls', [])
    .controller('PackagesController', PackagesController)
    .controller('PackagesAddController', PackagesAddController)
    .controller('PackagesEditController', PackagesEditController);

PackagesController.$inject = ['$rootScope', '$scope', 'ProductService', 'PackagesService', 'ClusterService', '$modal', '$ioAlert', '$state', 'ModalService', '$confirm', 'filterFilter', 'FormService'];

function PackagesController($rs, $scope, ProductService, PackagesService, ClusterService, $modal, $ioAlert, $state, ModalService, $confirm, filterFilter, FormService) {

    $scope.lookupTypes = [];
    $scope.showActiveFormListGroup = true;
    $scope.lookupContentKeys = [];
    $scope.uploadMedia = {};
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.packageData = [];
    $scope.disableBtnAction = false;
    $scope.hideTrashIcon = false;

    var getAllPackages = function (data) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetch LookUp Types";
        PackagesService.getPackages(data).then(function (success) {
            $scope.packageData = PackagesService.Packages;
            $rs.loadingInProgress = false;
            $scope.hideTrashIcon = !$scope.showActiveFormListGroup;
        }, function (error) {
            console.log("error loading packages types");
            $rs.loadingInProgress = false;
            $scope.hideTrashIcon = !$scope.showActiveFormListGroup;
        });
    };

    // search based on user text
    $scope.updateSearch = function () {
        if ($scope.searchPackages) {
            $scope.filteredLookupTypes = filterFilter($scope.lookupTypes, $scope.searchPackages);
        }
    };

    $scope.filterFormListGroupsActiveColumn = function () {
        $scope.showActiveFormListGroup = !$scope.showActiveFormListGroup;
        if ($scope.showActiveFormListGroup == true) {
            getAllPackages(1);
        } else if ($scope.showActiveFormListGroup == false) {
            getAllPackages(0);
        }
        $scope.sortableIconShowHide = $scope.showActiveFormListGroup;
    };

    function showModal(type, data) {
        data.lookupContentKeys = $scope.lookupContentKeys;
        data.lookupTypeIdNames = [];
        for (var i = 0; i < $scope.lookupTypes.length; i++) {
            data.lookupTypeIdNames[i] = $scope.lookupTypes[i].name;
            if (data.lookupType && data.lookupType.parent_lookup_type_id == $scope.lookupTypes[i].id) {
                data.parentLookupTypeName = $scope.lookupTypes[i].name;
            }
        }
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.importPackages = function () {
        if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded dont refresh the page', 'success');
            PackagesService.importPackages($scope.uploadMedia.file).then(function (response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                } else {
                    getAllPackages(1);
                    $ioAlert.show('', 'File Imported successfully', 'success');
                }
            }, function (error) {
                console.log("error loading packages keys");
            });
        } else {
            //$ioAlert.show("Error!", "Upload atleast one file", 'error');
        }
    };

    $scope.exportPackages = function () {
        PackagesService.exportPackages().then(function (response) {
            var csvString = response.data;
            var a = $('<a/>', {
                style: 'display:none',
                href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                download: 'Packages.csv'
            }).appendTo('body');
            a[0].click();
            a.remove();
        }, function (error) {
            console.log("error loading Package keys");
        });
    }

    $scope.addType = function (lookupType) {
        $state.go('Packagesadd');
    };

    $scope.editType = function (packages) {
        $state.go('Packagesedit', { 'packages': packages });
    };

    $scope.gotoLookupTypes = function () {
        $state.go('lookupTypes');
    };

    $scope.deleteType = function (data) {
        var index = $scope.packageData.indexOf(data);
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Package?'
        }).then(function (success) {
            PackagesService.deletePackage(data.id).then(function (success) {
                $ioAlert.show('Package Deleted', 'Package has been deleted successfully', 'success');
                $scope.packageData.splice(index, 1);
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        });
    }

    /*
    * Handle get instance lock configuration
    */
   var getInstanceLockConfig = function() {
    FormService.getInstanceLockConfig().then(function(data) {
        if(data.instanceLocked) {
            $scope.disableBtnAction = true;
        } else {
            $scope.disableBtnAction = false;
        }

    }, function(error) {
        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
    });
}

    $scope.init = function () {
        ClusterService.initCluster($rs.userRole, 'hidden');
        getInstanceLockConfig();
        getAllPackages(1);
    };

    $scope.init();
}

PackagesAddController.$inject = ['$rootScope', '$scope', '$stateParams', 'ProductService', 'PackagesService', 'ClusterService', '$state', '$modal', '$ioAlert', 'ModalService', 'filterFilter', '$confirm','$filter'];

function PackagesAddController($rs, $scope, $stateParams, ProductService, PackagesService, ClusterService, $state, $modal, $ioAlert, ModalService, filterFilter, $confirm,$filter) {

    $scope.products = [];
    $scope.selProduct = "";
    $scope.productFields = [];
    $scope.showNewTemplate = false;
    $scope.savedsuccessfully = false;
    $scope.addmode = false;
    $scope.packageObj = {};
    $scope.regex = /^[a-zA-Z0-9\s'-\(\)]+$/;
    $scope.name = "Add a New Package";
    var datacame = null;
    $scope.tempobj = {};
    $scope.disabled = {};
    $scope.packageObj.Active = false;
    $scope.templates = [{ colId: 'col1', product_field_id: '', field_name: '', data_type: '', isDisabled: true, isNotSaved: true, isEditable: true, isAdd: true }];
    $scope.inputTypes = ['geo-location', 'device-capability', 'devices', 'dfp_ad_units', 'DFP', 'textarea', 'text', 'select', 'select2', 'multiselect-custom', 'multiselect', 'connection', 'checkbox', 'currency', 'percentage','calculated','timeselect','calculated-override','dfp-frequency'];
    $scope.datatype = [];
    $scope.tagHandler = function (value) {
        return {
            label: value,
            lookup_value: value
        };
    }

    $scope.addGetProductClusters = function (data) {
        PackagesService.getClusters(data).then(function (response) {
            $scope.clusterArr = PackagesService.Clusters;
            $rs.loadingInProgress = false;
        }, function (error) {
            console.log("error loading clusters");
            $rs.loadingInProgress = false;
        });
        $scope.addGetAllProductFields(data);
    };
    $scope.addGetAllProductFields = function (data) {
        PackagesService.getProductFields(data).then(function (response) {
            $scope.productFields = response;
        }, function (error) {
            console.log("error loading clusters");
            $rs.loadingInProgress = false;
        });
    };

    $scope.setDefaultValuesAdd = function (data) {
        $modal.open(
            ModalService.returnModalType('packageSetDefault', data)
        ).result.then(function (res) {
            var test = res;
        });
    };

    var addGetProducts = function () {
        $scope.products = [];
        var showAll = 'no'
        ProductService.getAllProducts(showAll).then(function (success) {
            $scope.products = ProductService.products;

        }, function (error) {

        });
    };

    $scope.addOpenRelatedData = function (template, index) {
        const field = $scope.productFields.find (field => field.field_name == template.field_name);
        if (field) {
            template.data_type = field.data_type;
            template.product_field_id = field.id;
            template.input_type = field.input_type;
            template.content_key = field.content_key;
            template.lookUpValues =[];
        }
        if (!template.content_key) {
            PackagesService.getlookupcontentsByFieldName(template.field_name).then(function (response) {
                if(response.data && response.data.data){
                    template.lookUpValues = response.data.data;
                }
            }, function (error) {
            });
        } else if (template.data_type == 'string') {
            PackagesService.getlookupcontents(template.content_key).then(function (response) {
                if (response?.data?.lookupContents?.length > 0) {
                    template.lookUpValues = response.data.lookupContents;
                    if (template.field_name == "dfp_adsizes") {
                        $scope.imageTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.indexOf('v (Custom)') == -1 && item.lookup_value.slice(-1) !== "v"
                        );
                        $scope.videoTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.includes('v (Custom)') || item.lookup_value.slice(-1) == "v"
                        );
                        let obj = $scope.templates.find(item => item.field_name == "creative_type");
                        template.lookUpValues =[];
                        if (obj) {
                            if (obj.field_values == "Display") {
                                template.lookUpValues = $scope.imageTypeAdSizes;
                            } else if (obj.field_values == "Video") {
                                template.lookUpValues = $scope.videoTypeAdSizes;
                            }
                        }
                    }
                }
            }, function (error) {
            });
        }
    }

    $scope.restrictAlphabets = function (event, template) {
        var obj = $scope.templates.find(item => {
            return item.field_name == "creative_type"
        })
        if (template.field_name == "dfp_adsizes") {
            if(obj){
                if (obj.field_values != "Video" && obj.field_values != "Display") {
                    const e = event;
                    if ([''].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                    setTimeout(function () {
                        $(':focus').blur();
                    })
                    $ioAlert.show('Error!', 'Please select Ad Type and try again.');
                }
                else if (obj.field_values == "Video") {
                    const e = event;
                    if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', 'V', 'v'].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                } else if (obj.field_values == "Display") {
                    const e = event;
                    if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', ':'].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                } else {
                    $ioAlert.show('Error!', 'Please select Ad Type and try again.');
                }
            } else{
                const e = event;
                if ([''].indexOf(e.key) === -1) {
                    e.preventDefault();
                }
                setTimeout(function () {
                    $(':focus').blur();
                })
                $ioAlert.show('Error!', 'Please select Ad Type and try again.');
            }
        }
    }


    $scope.onSelectAdSizes = function (template) {
        var obj = $scope.templates.find(item => {
            return item.field_name == "creative_type"
        })
        if(template.field_name == 'dfp_adsizes'){
            if(obj){
                if (obj.field_values == "Video") {
                    template.field_values.forEach((element, index, array) => {
                        var regExp1 = (/^\d{1,4}[X|x]\d{1,4}[V|v]$/g).test(template.field_values[index]);
                        var regExp2 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(][\s]Custom[\s][\)]$/g).test(template.field_values[index]);
                        var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\(]Video[\/]Vast|VAST[\)][\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        if (regExp1 || regExp2 || regExp3 || regExp4) {
                            $scope.dfpAdsizesVlidationStatus = "true";
                        } else {
                            $scope.dfpAdsizesVlidationStatus = "false";
                            if (index == 0) {
                                template.field_values.splice(index,1);
                            } else if (index != 0) {
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            }
                        }
                    });
                }
                else if (obj.field_values == "Display") {
                    template.field_values.forEach((element, index, array) => {
                        var regExp1 = (/^\d{1,4}[X|x]\d{1,4}$/g).test(template.field_values[index]);
                        var regExp2 = (/^(4|6)[:](1)$/g).test(template.field_values[index]);
                        var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(][\s]Custom[\s][\)]$/g).test(template.field_values[index]);
                        var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        var regExp5 = (/[a-zA-Z &+,:;=?@#|'<>.^*()%!-]+$/g).test(template.field_values[index]);
                        if (regExp1 || regExp2 || regExp3 || regExp4 || regExp5) {
                            if (template.field_values[index] == 'x' || template.field_values[index] == 'X' || template.field_values[index] == ':') {
                                $scope.dfpAdsizesVlidationStatus = "false";
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            } else {
                                $scope.dfpAdsizesVlidationStatus = "true";
                            }
                        } else {
                            $scope.dfpAdsizesVlidationStatus = "false";
                            if (index == 0) {
                                template.field_values.splice(index,1);
                            } else if (index != 0) {
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            }
                        }
                    });
                }
            } else{
                $ioAlert.show('Error!', 'Please select Ad Type and try again.');
            }
        }
    }


    $scope.addNewTemplate = function () {
        $scope.showNewTemplate = true;
        var newItemNo = $scope.templates.length + 1;
        $scope.templates.push({ colId: 'col' + newItemNo, product_field_id: '', field_name: '', data_type: '', input_type: '', isDisabled: false, isNotSaved: false, isEditable: true, isAdd: true });
    }

    $scope.clearTemplate = function () {
        $scope.new = {};
        $scope.showNewTemplate = false;
    }
    $scope.addEditProductFields = function (index, template) {
        $scope.templates.forEach(template => {template.isDisabled = true;});
        $scope.templates[index].isDisabled = false;

        $scope.disabled[$scope.templates[index].field_name] = false;
        $scope.tempobj = angular.copy($scope.templates[index]);
        if (template.field_name == "dfp_adsizes") {
            let obj = $scope.templates.find(item => item.field_name == 'creative_type');
            template.lookUpValues =[];
            if (obj && template.content_key) {
                PackagesService.getlookupcontents(template.content_key).then(function (response) {
                    if (response?.data?.lookupContents?.length > 0) {
                        $scope.imageTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.indexOf('v (Custom)') == -1 && item.lookup_value.slice(-1) !=="v"
                        );
                        $scope.videoTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.includes('v (Custom)') || item.lookup_value.slice(-1) == "v"
                        );
                        if (obj.field_values == "Display") {
                            template.lookUpValues = $scope.imageTypeAdSizes;
                        } else if(obj.field_values == "Video"){
                            template.lookUpValues = $scope.videoTypeAdSizes;
                        }
                    }
                })
            }
        }
    }

    $scope.filterInputTypes = function (item) {
        return $scope.inputTypes.indexOf(item.input_type) !== -1;
    };

    $scope.savePackage = function (packageAddForm) {
        if (packageAddForm.$valid) {
            if ($scope.packageObj.clusterIds == undefined || $scope.packageObj.clusterIds == []) {
                $ioAlert.show('', 'Please select Business Unit', 'error');
                return;
            }
            var param = {};
            param['product_id'] = $scope.packageObj.selProduct;
            param['cluster_id'] = $scope.packageObj.clusterIds;
            if ($scope.packageObj.Active == true) {
                param['active'] = "1";
            } else if ($scope.packageObj.Active == false) {
                param['active'] = "0";
            }

            param['package_name'] = $scope.packageObj.Package_Name;
            PackagesService.AddPackages(param).then(function (data) {
                $ioAlert.show('', 'Package  Added successfully', 'success');
                $scope.showActiveFormListGroup = true;
                $scope.savedsuccessfully = true;
                $scope.savedPackage = param;
                $scope.savedPackageid = data.data.id;
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });

        } else {
            if (!$scope.regex.test($scope.packageObj.Package_Name)) {
                $ioAlert.show('', 'Package name contains invalid character(s).', 'error');
            } else {
                $ioAlert.show('', 'Please fill the required fields', 'error');
            }
            return;
        }
    };

    $scope.updatePackageName = function (packageObj) {
        if (packageObj.Package_Name && packageObj.Package_Name !== "") {
            var data = {
                    'package_name': packageObj.Package_Name,
                    'id': $scope.savedPackageid,
                    'active': packageObj.Active ? '1' : '0'
            }
            PackagesService.updatePackages(data, $scope.savedPackageid).then(function (data) {
                $ioAlert.show('', 'Package  updated successfully', 'success');
                $scope.showActiveFormListGroup = true;
                $state.go('Packagesview');
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        }
        else {
            $ioAlert.show('Error!', "Please fill mandatory fields", 'error');
        }
    };


    $scope.addSwitch = function (index) {
        $scope.templates[index].isEditable = !$scope.templates[index].isEditable;
    }

    $scope.addSaveFields = function (index, template) {
        if (template.field_name == "") {
            $ioAlert.show('Error!', 'please select Field Name', 'error');
            return;
        }
        let data = {
            'product_package_id': $scope.savedPackageid,
            'product_field_id': template.product_field_id,
            'active': $scope.savedPackage.active,
            'id': template.product_package_field_id,
            'is_editable': template.isEditable == true ? "1" : "0"
        }
        const validateError = PackagesService.validateAndFormatData(data, template);
        if (validateError) {
            $ioAlert.show('Error!', validateError, 'error');
            return;
        }

        if ($scope.templates[index].product_package_field_id == undefined || $scope.templates[index].product_package_field_id == " ") {
            PackagesService.saveProductFields(data).then(function (data) {
                $ioAlert.show('', 'Product Fields  Saved successfully', 'success');
                //$scope.editsavedsuccessfully = true;
                $scope.templates[index].isthere = true;
                template.isNotSaved = false;
                template.isDisabled = true;
                template.isAdd = false;
                template.product_package_field_id = data.data.id;
                $scope.showActiveFormListGroup = true;
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        } else {
            PackagesService.updateProductFields(data, $scope.templates[index].product_package_field_id).then(function (data) {
                $ioAlert.show('', 'Product Fields  updated successfully', 'success');
                $scope.templates[index].isthere = true;
                template.isNotSaved = false;
                template.isDisabled = true;
                template.isAdd = false;
                $scope.showActiveFormListGroup = true;
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        }
    }

    $scope.addGotodisable = function (index) {
        if ($scope.tempobj.field_name != "") {
            $scope.templates[index].field_name = $scope.tempobj.field_name;
            $scope.templates[index].product_field_id = $scope.tempobj.product_field_id;
            $scope.templates[index].data_type = $scope.tempobj.data_type;
            $scope.templates[index].isDisabled = true;
            $scope.templates[index].isNotSaved = false;
            $scope.template[index].isAdd = true;
            if ($scope.templates[index].isthere == true) {
                $scope.disabled[$scope.templates[index].field_name] = true;
            }
        } else {
            $scope.templates[index].field_name = "";
            $scope.templates[index].product_field_id = "";
            $scope.templates[index].data_type = "";
            $scope.templates[index].isDisabled = true;
        }
    }

    $scope.addDeleteTemplate = function (index) {
        if (!$scope.templates[index].product_package_field_id) {
            $scope.templates.splice(index, 1);
        } else {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Product Field?'
            }).then(function (success) {
                PackagesService.deleteProductFields($scope.templates[index].product_package_field_id).then(function (success) {
                    $ioAlert.show('Product Field Deleted', 'Product Field has been deleted successfully', 'success');
                    $scope.disabled[$scope.templates[index].field_name] = false;
                    $scope.templates.splice(index, 1);
                    if ($scope.templates.length == 0) {
                        $scope.templates = [{ colId: 'col1', product_field_id: '', field_name: '', data_type: '', isDisabled: true, isNotSaved: true, isEditable: true }];
                    }

                }, function (error) {
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            });
        }
    }

    $scope.clear = function () {
        $scope.packageObj.clusterIds = [];
    }

    $scope.backtoPackages = function () {
        $state.go('Packagesview');
    };

    $scope.init = function () {
        ClusterService.initCluster($rs.userRole, 'hidden');
        addGetProducts();

    };
    $scope.init();

}
PackagesEditController.$inject = ['$rootScope', '$scope', '$stateParams', 'ProductService', 'PackagesService', 'ClusterService', '$state', '$modal', '$ioAlert', 'ModalService', 'filterFilter', '$confirm','$filter', 'FormService'];

function PackagesEditController($rs, $scope, $stateParams, ProductService, PackagesService, ClusterService, $state, $modal, $ioAlert, ModalService, filterFilter, $confirm,$filter, FormService) {

    $scope.products = [];
    $scope.selProduct = "";
    $scope.productFields = [];
    $scope.showNewTemplate = false;
    $scope.editsavedsuccessfully = false;
    $scope.addmode = true;
    $scope.packageEditObj = {};
    var datacame = null;
    $scope.tempobj = {};
    $scope.name = "Edit Package";
    $scope.templates = [];
    $scope.disabled = {};
    $scope.datatype = [];
    $scope.disableBtnAction = false;
    $scope.packageEditObj.clusterIds =[];
    $scope.selectedClustersList = [];
    $scope.selectedClusters=[];
    $scope.inputTypes = ['geo-location', 'device-capability', 'devices', 'dfp_ad_units', 'DFP', 'textarea', 'text', 'select', 'select2', 'multiselect-custom', 'multiselect', 'connection', 'checkbox', 'currency', 'percentage','calculated','timeselect','calculated-override','dfp-frequency'];
    $scope.editGetAllProductFields = function (data) {
        PackagesService.getProductFields(data).then(function (response) {
            $scope.productFields = response;
        }, function (error) {
            console.log("error loading clusters");
            $rs.loadingInProgress = false;
        });
    };

    $scope.filterInputTypes = function (item) {
        return $scope.inputTypes.indexOf(item.input_type) !== -1;
    };

    $scope.tagHandler = function (value) {
        return {
            label: value,
            lookup_value: value
        };
    }

    $scope.editGetListProductFields = function (data) {
        PackagesService.getEditproductfields(data).then(function (response) {
            if(response.cluster_data){
                $scope.selectedClustersList = response.cluster_data; 
                $scope.packageEditObj.selectedClusters = response.cluster_data;
            }
            if (!response.package_data || response.package_data.length == 0) {
                $scope.templates.push({ colId: 'col1', product_field_id: '', field_name: '', data_type: '', isDisabled: true, isNotSaved: true, isEditable: true, isAdd: true });
            }
            else {
                for (var i = 0; i < response.package_data.length; i++) {
                    $scope.templates.push({
                        colId: 'col' + i,
                        product_field_id: response.package_data[i].product_field_id,
                        field_name: response.package_data[i].field_name,
                        product_package_field_id: response.package_data[i].id,
                        data_type: response.package_data[i].data_type,
                        input_type: response.package_data[i].input_type,
                        field_values: (response.package_data[i].data_type !== 'json' && response.package_data[i].field_values !== "Array") ? JSON.parse(response.package_data[i].field_values) : response.package_data[i].field_values,
                        isEditable: response.package_data[i].is_editable === "1",
                        isDisabled: true,
                        isNotSaved: false,
                        isAdd: false,
                        content_key: response.package_data[i].content_key
                    });
                    $scope.disabled[$scope.templates[i].field_name] = true;
                    $scope.templates[i].isthere = true;
                }

            }
            $scope.parseFieldData($scope.templates);
        }, function (error) {
            console.log("error loading clusters");
            $rs.loadingInProgress = false;
        });
    }


    $scope.parseFieldData = function (fieldData) {
          let fieldValObj = [];
        _.each(fieldData, function (item) {
            if (item.field_values && item.field_values.length == 1) {
                if (item.input_type=='timeselect') {
                    var timeObj = new Date();
                    var timeVal = String(item.field_values[0]).split(":");
                    item.field_values = new Date(timeObj.getFullYear(), timeObj.getMonth(), timeObj.getDate(), parseInt(timeVal[0]), parseInt(timeVal[1]), 0);
                } else if (item.input_type=='multiselect-custom') {
                      fieldValObj = [];
                    _.each(item.field_values, function (value) {
                        fieldValObj.push({
                          label: value,
                          lookup_value: value
                        });
                      });
                      item.field_values = fieldValObj;
                } else {
                    if (item.input_type != 'multiselect-custom' && item.input_type != 'multiselect') {
                        item.field_values = item.field_values[0];
                    } 
                }
            } else {
                if (item.input_type=='multiselect-custom') {
                      fieldValObj = [];
                    _.each(item.field_values, function (value) {
                        fieldValObj.push({
                          label: value,
                          lookup_value: value
                        });
                      });
                      item.field_values = fieldValObj;
                }
            }
            if (!item.content_key) {
                PackagesService.getlookupcontentsByFieldName(item.field_name).then(function (response) {
                    if (response.data && response.data.data) {
                        item.lookUpValues = response.data.data;
                    }
                }, function (error) {
                    console.log("error loading values");
                });
            } else if (item.data_type == 'string') {
                PackagesService.getlookupcontents(item.content_key).then(function (response) {
                    if (response?.data?.lookupContents?.length > 0) {
                        item.lookUpValues = response.data.lookupContents;
                    }
                }, function (error) {
                });
            }
        })
    }

    $scope.editSwitch = function (index) {
        $scope.templates[index].isEditable = !$scope.templates[index].isEditable;
    }

    var editGetProducts = function () {
        $scope.products = [];
        var showAll = 'no'
        ProductService.getAllProducts(showAll).then(function (success) {
            $scope.products = ProductService.products;
        }, function (error) {

        });
    };

    $scope.editOpenRelatedData = function (template, index) {
        const field = $scope.productFields.find (field => field.field_name == template.field_name);
        if (field) {
            template.data_type = field.data_type;
            template.product_field_id = field.id;
            template.input_type = field.input_type;
            template.content_key = field.content_key;
            template.lookUpValues =[];
        }
        // content_key could be empty string or null
        if (!template.content_key) {
            PackagesService.getlookupcontentsByFieldName(template.field_name).then(function (response) {
                if (response?.data?.data) {
                    template.lookUpValues = response.data.data;
                }
            }, function (error) {
                console.log("error loading values");
            });
        } else if (template.data_type == 'string') {
            PackagesService.getlookupcontents(template.content_key).then(function (response) {
                if (response?.data?.lookupContents?.length > 0) {
                    template.lookUpValues = response.data.lookupContents;
                    if (template.field_name == "dfp_adsizes") {
                        $scope.imageTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.indexOf('v (Custom)') == -1 && item.lookup_value.slice(-1) !=="v"
                        );
                        $scope.videoTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.includes('v (Custom)') || item.lookup_value.slice(-1) == "v"
                        );
                        template.lookUpValues =[];
                        let obj = $scope.templates.find(item => item.field_name == "creative_type");
                        if (obj) {
                            if (obj.field_values == "Display") {
                                template.lookUpValues = $scope.imageTypeAdSizes;
                            } else if (obj.field_values == "Video"){
                                template.lookUpValues = $scope.videoTypeAdSizes;
                            }
                        }
                    }
                }
            }, function (error) {
            });
        }
    }
    $scope.editAddNewTemplate = function () {
        $scope.showNewTemplate = true;
        var newItemNo = $scope.templates.length + 1;
        $scope.templates.push({ colId: 'col' + newItemNo, product_field_id: '', field_name: '', data_type: '', input_type: '', isDisabled: false, isNotSaved: false, isEditable: true, isAdd: true });
    }
    $scope.clearTemplate = function () {
        $scope.new = {};
        $scope.showNewTemplate = false;
    }
    $scope.editProductFields = function (index, template) {
        $scope.templates.forEach(template => {template.isDisabled = true;});
        $scope.templates[index].isDisabled = false;

        $scope.disabled[$scope.templates[index].field_name] = false;
        $scope.tempobj = angular.copy($scope.templates[index]);
        if (template.field_name == "dfp_adsizes") {
            template.lookUpValues =[];
            let obj = $scope.templates.find(item => item.field_name == "creative_type");
            if (obj && template.content_key) {
                PackagesService.getlookupcontents(template.content_key).then(function (response) {
                    if (response?.data?.lookupContents?.length > 0) {
                        $scope.imageTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.indexOf('v (Custom)') == -1 && item.lookup_value.slice(-1) !=="v"
                        );
                        $scope.videoTypeAdSizes = response.data.lookupContents.filter(
                            (item) => item.lookup_value.includes('v (Custom)') || item.lookup_value.slice(-1) == "v"
                        );
                        template.lookUpValues =[];
                        if (obj.field_values == "Display") {
                            template.lookUpValues = $scope.imageTypeAdSizes;
                        } else if (obj.field_values == "Video") {
                            template.lookUpValues = $scope.videoTypeAdSizes;
                        }
                    }
                });
            }
        }
    }

    $scope.updatePackage = function (packageEditForm) {
        if (packageEditForm.$valid) {
            var data = {
                'package_name': $scope.packageEditObj.Package_Name,
                'id': $stateParams.packages.id,
                'active': $scope.packageEditObj.active ? '1' : '0'
            }
            PackagesService.updatePackages(data, $stateParams.packages.id).then(function (data) {
                $ioAlert.show('', 'Package  updated successfully', 'success');
                $scope.showActiveFormListGroup = true;
                $state.go('Packagesview');
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        }
        else{
            $ioAlert.show('Error!',"Please fill mandatory fields", 'error');
        }
    }

    $scope.restrictAlphabets = function (event, template) {
        var obj = $scope.templates.find(item => {
            return item.field_name == "creative_type"
        })
        if (template.field_name == "dfp_adsizes") {
            if(obj){
                if (obj.field_values != "Video" && obj.field_values != "Display") {
                    const e = event;
                    if ([''].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                    setTimeout(function () {
                        $(':focus').blur();
                    })
                    $ioAlert.show('Error!', 'Please select Ad Type and try again.');
                }
                else if (obj.field_values == "Video") {
                    const e = event;
                    if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', 'V', 'v'].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                } else if (obj.field_values == "Display") {
                    const e = event;
                    if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', ':'].indexOf(e.key) === -1) {
                        e.preventDefault();
                    }
                } else {
                    $ioAlert.show('Error!', 'Please select Ad Type and try again.');
                }
            } else{
                const e = event;
                if ([''].indexOf(e.key) === -1) {
                    e.preventDefault();
                }
                setTimeout(function () {
                    $(':focus').blur();
                })
                $ioAlert.show('Error!', 'Please select Ad Type and try again.');
            }
        }
    }


    $scope.onSelectAdSizes = function (template) {
        var obj = $scope.templates.find(item => {
            return item.field_name == "creative_type"
        })
        if(template.field_name == 'dfp_adsizes'){
            if(obj){
                if (obj.field_values == "Video") {
                    template.field_values.forEach((element, index, array) => {
                        var regExp1 = (/^\d{1,4}[X|x]\d{1,4}[V|v]$/g).test(template.field_values[index]);
                        var regExp2 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(][\s]Custom[\s][\)]$/g).test(template.field_values[index]);
                        var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\(]Video[\/]Vast|VAST[\)][\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        if (regExp1 || regExp2 || regExp3 || regExp4) {
                            $scope.dfpAdsizesVlidationStatus = "true";
                        } else {
                            $scope.dfpAdsizesVlidationStatus = "false";
                            if (index == 0) {
                                template.field_values.splice(index,1);
                            } else if (index != 0) {
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            }
                        }
                    });
                }
                else if (obj.field_values == "Display") {
                    template.field_values.forEach((element, index, array) => {
                        var regExp1 = (/^\d{1,4}[X|x]\d{1,4}$/g).test(template.field_values[index]);
                        var regExp2 = (/^(4|6)[:](1)$/g).test(template.field_values[index]);
                        var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(][\s]Custom[\s][\)]$/g).test(template.field_values[index]);
                        var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(]Custom[\)]$/g).test(template.field_values[index]);
                        var regExp5 = (/[a-zA-Z &+,:;=?@#|'<>.^*()%!-]+$/g).test(template.field_values[index]);
                        if (regExp1 || regExp2 || regExp3 || regExp4 || regExp5) {
                            if (template.field_values[index] == 'x' || template.field_values[index] == 'X' || template.field_values[index] == ':') {
                                $scope.dfpAdsizesVlidationStatus = "false";
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            } else {
                                $scope.dfpAdsizesVlidationStatus = "true";
                            }
                        } else {
                            $scope.dfpAdsizesVlidationStatus = "false";
                            if (index == 0) {
                                template.field_values.splice(index,1);
                            } else if (index != 0) {
                                template.field_values.splice(index, 1);
                                $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                            }
                        }
                    });
                }
            } else{
                $ioAlert.show('Error!', 'Please select Ad Type and try again.');
            }
        }
    }
    

    $scope.editSaveFields = function (index, template) {
        if (template.field_name == "") {
            $ioAlert.show('Error!', 'please select Field Name', 'error');
            return;
        }
        let data = {
            'product_package_id': $stateParams.packages.id,
            'product_field_id': template.product_field_id,
            'active': $stateParams.packages.active,
            'id': template.product_package_field_id,
            'is_editable': template.isEditable == true ? "1" : "0"
        }
        const validateError = PackagesService.validateAndFormatData(data, template);
        if (validateError) {
            $ioAlert.show('Error!', validateError, 'error');
            return;
        }

        if (template.product_package_field_id == undefined || template.product_package_field_id == " ") {
            PackagesService.saveProductFields(data).then(function (data) {
                $ioAlert.show('', 'Product Fields  Saved successfully', 'success');
                template.isNotSaved = false;
                template.isAdd = false;
                template.isDisabled = true;
                template.product_package_field_id = data.data['id'];
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        } else {
            PackagesService.updateProductFields(data, template.product_package_field_id).then(function (data) {
                $ioAlert.show('', 'Product Fields  updated successfully', 'success');
                template.isNotSaved = false;
                template.isAdd = false;
                template.isDisabled = true;
                //$scope.editsavedsuccessfully = true;
                //$scope.showActiveFormListGroup = true;
            }, function (error) {
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        }
    }

    $scope.editGotodisable = function (index) {
        if ($scope.tempobj.field_name != "") {
            $scope.templates[index].field_name = $scope.tempobj.field_name;
            $scope.templates[index].product_field_id = $scope.tempobj.product_field_id;
            $scope.templates[index].data_type = $scope.tempobj.data_type;
            $scope.templates[index].isDisabled = true;
            $scope.templates[index].isNotSaved = false;
            $scope.templates[index].isAdd = false;
            if ($scope.templates[index].isthere == true) {
                $scope.disabled[$scope.templates[index].field_name] = true;
            }
        } else {
            $scope.templates[index].field_name = "";
            $scope.templates[index].product_field_id = "";
            $scope.templates[index].data_type = "";
            $scope.templates[index].isDisabled = true;
        }
    }

    $scope.editDeleteTemplate = function (index) {
        if (!$scope.templates[index].product_package_field_id) {
            $scope.templates.splice(index, 1);
        } else {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Product Field?'
            }).then(function (success) {
                PackagesService.deleteProductFields($scope.templates[index].product_package_field_id).then(function (success) {
                    $ioAlert.show('Product Field Deleted', 'Product Field has been deleted successfully', 'success');
                    $scope.disabled[$scope.templates[index].field_name] = false;
                    $scope.templates.splice(index, 1);
                }, function (error) {
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            });
        }

    }

    $scope.setDefaultValuesEdit = function (data) {
        $modal.open(
            ModalService.returnModalType('packageSetDefault', data)
        ).result.then(function (res) {
            var test = res;
        });
    };

    $scope.backtoPackages = function () {
        $state.go('Packagesview');
    };

    /*
    * Handle get instance lock configuration
    */
   var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.init = function () {
        ClusterService.initCluster($rs.userRole, 'hidden');
        getInstanceLockConfig();
        editGetProducts();
        $scope.packageEditObj.Package_Name = $stateParams.packages.package_name;
        $scope.packageEditObj.active = ($stateParams.packages.active == '1');
        $scope.editGetAllProductFields($stateParams.packages.product_id);
        $scope.editGetListProductFields($stateParams.packages.id);
    };
    $scope.init();

}
